import { Component, ChangeDetectionStrategy } from "@angular/core";
import { DialogTemplateComponent } from "../dialog-template.component";

@Component({
  standalone: true,
  selector: "app-dialog-main",
  templateUrl: "./main.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./main.component.less",
})
export class MainComponent extends DialogTemplateComponent {
  public constructor() {
    super();
  }
}
